module.exports = __webpack_public_path__ + "img/sa.2be8c2ce.jpg";